
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import unionBy from 'lodash/unionBy';

import katuzeGetActions from '../../sagas/katuze';
import projectGetActions from '../../sagas/project';
import { getProject, getProjectKatuzeItems, getProjectStatus } from '../../reducers/project';
import { getKatuzeItems } from '../../reducers/katuze';

import IfComp from '../common/IfComp';
import ToolbarCommandButton from '../common/ToolbarCommandButton';
import KatuzeItems from './KatuzeItems';
import OverviewPanel from './OverviewPanel';
import DialogAddKatuze from './DialogAddKatuze';

const classNames = mergeStyleSets({
    content: {
        paddingTop: 16
    }
});

const OverviewPanelKatuze = (props) => {

    const dispatch = useDispatch();
    const katuzeActions = katuzeGetActions(dispatch);
    const projectActions = projectGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const project = useSelector(state => getProject(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const projectStatus = useSelector(state => getProjectStatus(state.project));

    const katuze = useSelector(state => state.katuze);
    const katuzeItems = useSelector(state => getKatuzeItems(state.katuze));

    const readOnly = (projectStatus !== 'DEF_KU');
    const canGoNext = (projectKatuzeItems.length > 0);

    useEffect(() => {
        if (!katuze.katuzeList && !katuze.loading && !katuze.error) {
            katuzeActions.getKatuze(token, project.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddKuClick = async () => {
        const data = await DialogAddKatuze.show(katuzeItems);
        if (data) {
            projectActions.setParameter(
                token, project.id, 'katuzeItems',
                JSON.stringify(
                    unionBy(projectKatuzeItems, data.selectedKatuzeItems, 'kod').sort((a, b) => {
                        if (a.nazev < b.nazev) {
                            return -1;
                        } else {
                            if (a.nazev > b.nazev) {
                                return 1;
                            } else {
                                return 0;
                            }
                        }
                    })
                )
            );
        }
    }

    const handleClickEdit = () => {
        projectActions.editKatuze(token, project.id);
    }

    const handleClickNext = () => {
        projectActions.setParameter(token, project.id, 'status', 'SELECT_OPSUB');
    }

    return (
        <OverviewPanel title="SEZNAM KATASTRÁLNÍCH ÚZEMÍ" loaded={katuze.loaded}>
            <Stack className={classNames.content} tokens={{childrenGap: 16}}>
                <KatuzeItems
                    katuzeItems={projectKatuzeItems}
                    readOnly={readOnly}
                />
                <IfComp cond={readOnly}>
                    <DefaultButton onClick={handleClickEdit}>Upravit seznam katastrálních území</DefaultButton>
                </IfComp>
                <IfComp cond={!readOnly}>
                    <ToolbarCommandButton items={[
                        {
                            text: 'Přidat KÚ',
                            title: 'Přidat katastrální území do seznamu',
                            onClick: handleAddKuClick
                        }
                    ]}/>
                    <PrimaryButton disabled={!canGoNext} onClick={handleClickNext}>Uložit seznam a pokračovat</PrimaryButton>
                </IfComp>

            </Stack>
        </OverviewPanel>
    );
}

export default OverviewPanelKatuze;
